import { fetch as fetchMap, setCurrentSetting } from 'actions/map';
import { IAppState } from 'types/app';
import { ISettingChangeMessage } from 'types/app/messages';

export default function processSettingChangeMessage(message: ISettingChangeMessage) {
  return (dispatch: Function, getState: () => IAppState) => {
    const { map } = getState();
    const { setting } = message;

    // Update our Setting
    dispatch(setCurrentSetting(setting));

    // If we are able to travel in the new Setting but have no
    // map locations, then retrieve them
    const { canTravel } = setting;

    if (canTravel && !map.areas) {
      dispatch(fetchMap());
    }

    return message;
  };
}